import { AcademicCapIcon, UserIcon } from '@heroicons/react/24/solid';
import { UserTypeSelectorProps } from '../../../types';

const UserTypeSelector: React.FC<UserTypeSelectorProps> = ({ value, onChange, className = '' }) => {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-3">
        I am a:
      </label>
      <div className="grid grid-cols-2 gap-3">
        <button
          type="button"
          onClick={() => onChange('professor')}
          className={`p-4 rounded-lg border-2 transition-all ${
            value === 'professor'
              ? 'border-emerald-500 bg-emerald-50 text-emerald-700'
              : 'border-gray-300 hover:border-gray-400'
          }`}
        >
          <AcademicCapIcon className="h-8 w-8 mx-auto mb-2" />
          <div className="text-sm font-medium">Professor</div>
        </button>
        <button
          type="button"
          onClick={() => onChange('student')}
          className={`p-4 rounded-lg border-2 transition-all ${
            value === 'student'
              ? 'border-emerald-500 bg-emerald-50 text-emerald-700'
              : 'border-gray-300 hover:border-gray-400'
          }`}
        >
          <UserIcon className="h-8 w-8 mx-auto mb-2" />
          <div className="text-sm font-medium">Student</div>
        </button>
      </div>
    </div>
  );
};

export default UserTypeSelector; 